import { BannerReducer } from './banner.reducer';

export const reducers = BannerReducer;
